import { ValidationError } from 'components/forms/validators/validation-error';

/**
 * Validates that the input is not empty.
 */
export default function required(value?: any): ValidationError | null {
  if (
    value === '' ||
    value === null ||
    value === undefined ||
    value === false ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return {
      message: 'Pole je povinné',
    };
  }

  return null;
}
